import { render, staticRenderFns } from "./CommunityForm.vue?vue&type=template&id=18955ef0&"
import script from "./CommunityForm.vue?vue&type=script&lang=js&"
export * from "./CommunityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports